angular.module("bccNgApp").controller('HeaderCancerSearchController', ["$scope", function ($scope) {

    $scope.searchTerm = "";
    $scope.list = [];

    $scope.init = function (list) {
        $scope.list = list;
    }
}]);